module.exports = __webpack_public_path__ + "static/media/ie.b4578b44.svg";